<template>
  <div>
    <Layout/>
	
    <!-- Breadcrumb -->
    <div class="breadcrumb-container">
      <router-link to="/atencion">Atenciones</router-link>
      &rsaquo;
      <router-link
        :to="{
          name: 'AtencionForm',
          state: { idAtencion: p_idAtencion }
        }"
      >
        Atención {{ p_numero }}
      </router-link>
      &rsaquo;
      <router-link
        :to="{
          name: 'AtencionForm',
          state: { idAtencion: p_idAtencion },
          query: { tab: 'tratamiento' }
        }"
      >
        Plan de Tratamiento
      </router-link>
      &rsaquo;
      <router-link :to="{
        name: 'Pedido_PedidoDet',
        state: {
          idAtencion:     p_idAtencion,
          estadoAtencion: p_estadoAtencion,
          tipo:           p_tipo,
          numero:         p_numero,
        }
      }">
        <span v-if="this.p_tipo === 'L'">Solicitud Laboratorio Clínico</span>
        <span v-else-if="this.p_tipo === 'I'">Solicitud Imagen</span>
      </router-link>
      &rsaquo;	  
      <b>
        Archivos de resultados
      </b>

    </div>
    <hr>
	
<!-- Master -->
<div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
          <div class="mb-3">
              <div class="row">
                <div class="col-6">
                  <label for="motivo" class="form-label">Motivo</label>
                  <textarea class="form-control" id="motivo" name="motivo" v-model="datoPedido.motivo" disabled></textarea>
                </div>
                <div class="col-6">
                  <label for="resumen" class="form-label">Resumen</label>
                  <textarea class="form-control" id="resumen" name="resumen" v-model="datoPedido.resumen" disabled></textarea>
                </div>
              </div>
            </div>
            <button @click.prevent="mostrarOcultarBloque">{{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}</button>
            <div v-if="mostrarBloque" class="mb-3">
              <div class="mb-3">
                <div class="row">
                  <div class="col-12">
                    <label for="observacion" class="form-label">Observación</label>
                    <textarea class="form-control" id="observacion" name="observacion" v-model="datoPedido.observacion" disabled></textarea>
                  </div>
                </div>
              </div>
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idPedido" class="form-label">Id</label>
                  </div>
                  <div class="col-2">
                    <input type="text" class="form-control" id="idPedido" name="idPedido" v-model="datoPedido.idPedido" disabled>
                  </div>
                  <div class="col-2">
                    <label for="fechaReg" class="form-label">FechaReg</label>
                  </div>
                  <div class="col-2">
                    <input type="text" class="form-control" id="fechaReg" name="fechaReg" v-model="datoPedido.fechaReg" disabled>
                  </div>
                  <div class="col-2">
                    <label for="fechaAct" class="form-label">FechaAct</label>
                  </div>
                  <div class="col-2">
                    <input type="text" class="form-control" id="fechaAct" name="fechaAct" v-model="datoPedido.fechaAct" disabled>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="upload-container">
        <form @submit.prevent="cargarArchivos">
          <div class="row">
            <div class="col-3">
              <label for="archivos"><b>Seleccionar Archivos:</b>&nbsp;</label>
            </div>
            <div class="col-6">
              <input type="file" id="inputArchivos" name="inputArchivos" class="btn btn-outline-info" @change="onFileChange" multiple required/>
            </div>
            <div class="col-3">
              <button type="submit" class="btn btn-outline-primary">
                <span class="material-symbols-outlined" style="font-size:24px;color:blue; cursor: pointer;">upload_file</span>
                Cargar Archivos
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

<!-- Details -->
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Archivo</th>
          <th scope="col"></th>
          <th scope="col"></th>
<!--           <th scope="col">Nombre</th>
          <th scope="col">Ruta</th>
          <th scope="col"></th>
          <th scope="col"></th>
 -->        </tr>
      </thead>
      <tbody>
        <tr v-for="archivo in datosPaginados" :key="archivo.idArchivo">
          <td>
            <span class="material-symbols-outlined" style="font-size:32px;color:darkblue; cursor: pointer;" @click="abrirModalEditar(archivo.idArchivo)" title="Ver información">
              quick_reference
            </span>
          </td>
          <td><a :href="transformarRutaEnURL(archivo.nombre)" target="_blank">{{archivo.nombre}}</a></td>
          <td style="text-align: right;">
              <button @click="openModal" class="btn btn-outline-danger">Abrir PDF</button>
              <file-viewer :fileUrl="transformarRutaEnURL(archivo.nombre)" v-model:visible="isModalVisible" />
          </td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteArchivo(archivo.idArchivo)" title="Borrar">delete</i></td>
<!--           <td>{{archivo.nombre}}</td>
          <td>{{archivo.ruta}}</td>
          <td><a :href="transformarRutaEnURL(archivo.ruta)" target="_blank">{{ archivo.ruta }}</a></td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deletePedido(archivo.idArchivo)" title="Borrar">delete</i></td>
 -->        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPaginaTodos(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-11">
                  <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoArchivo.nombre" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="ruta" class="form-label">Ruta</label>
                </div>
                <div class="col-11">
                  <input type="text" class="form-control" id="ruta" name="ruta" v-model="datoArchivo.ruta" disabled>
                </div>
              </div>
            </div>
            <button @click.prevent="mostrarOcultarBloqueDet">(+/-) Información</button>
            <div v-if="mostrarBloqueDet" class="mb-3">
              <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                  <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoArchivo.tipo" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tamano" class="form-label">Tamaño</label>
                </div>
                <div class="col-8">
                  <input type="text" class="form-control" id="tamano" name="tamano" v-model="datoArchivo.tamano" disabled>
                </div>
                <div class="col-2">
                  <label for="tamano" class="form-label">bytes</label>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idArchivo" class="form-label">IdArchivo</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="idArchivo" name="idArchivo" v-model="datoArchivo.idArchivo" disabled>
                </div>
                <div class="col-2">
                  <label for="idPedido" class="form-label">IdPedido</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="idPedido" name="idPedido" v-model="datoArchivo.idPedido" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaCrea" class="form-label">FechaCrea</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="fechaCrea" name="fechaCrea" v-model="datoArchivo.fechaCrea" disabled>
                </div>
                <div class="col-2">
                  <label for="fechaMod" class="form-label">FechaMod</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="fechaMod" name="fechaMod" v-model="datoArchivo.fechaMod" disabled>
                </div>
              </div>
            </div>
          </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import FileViewer from '../../components/FileViewer.vue';
import { validarForm } from '@/modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal2 from  'sweetalert2'
export default {
  props: {
    p_idAtencion:     { type: Number, required: true },
    p_estadoAtencion: { type: String, required: true },
    p_tipo:           { type: String, required: true },
    p_numero:         { type: String, required: true },
    p_idPedido:       { type: Number, required: true },
  },
  components : {
    Layout, Footer, FileViewer
  },
  data () {
    return {
// Variables master
      pedidos : [],
      datoPedido : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
// Variables master
      ruta: '',
      resultadoCarga: '',
      mostrarBloque: false,
      mostrarBloqueDet: false,
      files: [],
// Variables details
      archivos : [],
      datoArchivo : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
// Variables details
      isModalVisible: false,
    }
  },
  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)
    },
  },
  mounted () {
    this.abrirEditar(this.p_idPedido)
    this.getDataPaginaTodos(this.paginaActual)
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
    mostrarOcultarBloqueDet() {
      this.mostrarBloqueDet = !this.mostrarBloqueDet;
    },
    openModal() {
      this.isModalVisible = true;
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idTratamiento'
        ,'observacion'
      ];
      const requiredFieldsText = [
        'idTratamiento'
        ,'observacion'
      ];
      return validarForm(this.datoPedido, requiredFields, requiredFieldsText);
    },
    abrirEditar(idPedido){
      this.modalWindow = true
      if(idPedido != null){    
           api.get('/vwpedidos/'+idPedido).then(resp=>{
          this.datoPedido = resp.data;
           });
      }
      this.titulo   = 'Ver Archivos'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarPedido(){
      this.$router.push('/Pedido')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.archivos.length / this.elementosPorPagina)
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwarchivos/idpedido/'+this.p_idPedido).then(response=>{
      this.archivos=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.archivos.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idTratamiento'
        ,'observacion'
      ];
      const requiredFieldsText = [
        'idTratamiento'
        ,'observacion'
      ];
      return validarForm(this.datoPedido, requiredFields, requiredFieldsText);
    },
    abrirModalEditar(idArchivo){
      this.modalWindow = true
      if(idArchivo != null){    
           api.get('/vwarchivos/'+idArchivo).then(resp=>{
          this.datoArchivo = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Ver Archivos'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idArchivo){
      this.modalWindow = true
      if(idArchivo != null){
        this.$router.push('/archivomd/'+idArchivo)
      }
    },
    async deleteArchivo (idArchivo) {
      try{
        await api.delete('/archivos/'+idArchivo)
          this.getDataPaginaTodos(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    transformarRutaEnURL(ruta) {
      const baseURL = 'http://localhost:8081/archivos/';
      return baseURL + encodeURIComponent(ruta);
    },

    onFileChange(e) {
        this.archivos = e.target.files; // Almacena los archivos seleccionados
      },

    async cargarArchivos() {
      if (!this.archivos || this.archivos.length === 0) {
          swal2.fire({
              icon: 'error',
              title: 'Error',
              text: 'No se han seleccionado archivos para cargar.',
              showConfirmButton: true
          });
          return;
      }

      const formData = new FormData();
      formData.append('idAtencion', this.p_idAtencion);
      formData.append('idPedido', this.datoPedido.idPedido);

      // Añadir cada archivo seleccionado al FormData
      for (let i = 0; i < this.archivos.length; i++) {
          formData.append('archivos', this.archivos[i]);
      }

      try {
          const response = await api.post('/archivos/indexar', formData, {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
          });

          const data = response.data;

          if (data.archivosCargados && data.archivosCargados.length > 0) {
              await swal2.fire({
                  icon: 'success',
                  title: 'Archivos cargados correctamente',
                  html: 'Los archivos cargados son:<br>' + data.archivosCargados.join('<br>'),
                  showConfirmButton: true
              });
          }

          if (data.archivosDuplicados && data.archivosDuplicados.length > 0) {
              await swal2.fire({
                  icon: 'warning',
                  title: 'Archivos duplicados',
                  html: 'Los archivos duplicados son:<br>' + data.archivosDuplicados.join('<br>'),
                  showConfirmButton: true
              });
          }

      } catch (error) {
          console.error('Error al cargar archivos:', error);

          // Mostrar una alerta de error con SweetAlert2
          swal2.fire({
              icon: 'error',
              title: 'Error',
              text: 'Hubo un error al cargar los archivos. Inténtalo de nuevo.',
              showConfirmButton: true
          });
      }

      // Limpiar el input de archivos después de cargar
      this.archivos = [];  // Limpiar el array de archivos
      document.getElementById("inputArchivos").value = '';  // Limpiar el campo de selección de archivos

      // Actualizar los datos de la página
      this.getDataPaginaTodos(this.paginaActual);
    }

  },
}
</script>
<style scoped>
  .upload-container {
    justify-content: center;
    align-items: center;
    width: 80%;
    margin: 5px auto;
    padding: 5px;
    border: 2px solid #ccc;
    border-radius: 12px;
    background-color: #f7f9fc;
  }
</style>